import React from "react";
import { Link } from "react-router-dom";

const Hero = ({ background, title }) => {
  return (
    <div
      className="row justify-content-center hero-unit"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="col-12">
        <div className="hero-cta">
          <p>
            <Link to="/services">Back to Services</Link>
          </p>
          <h2>{title}</h2>
        </div>
      </div>
    </div>
  );
};

export default Hero;
